/*
  Éclore brides gallery lightbox — native <dialog>, no dependencies.
  Delegated so a single listener covers every trigger in the section.
*/
document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-eclore-brides-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.ecloreBridesOpen);
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      dialog.showModal();
    }
    return;
  }

  const closer = event.target.closest('[data-eclore-brides-close]');
  if (closer) {
    closer.closest('dialog')?.close();
    return;
  }

  // Click on the backdrop (outside dialog content) closes it
  const dialog = event.target.closest('[data-eclore-brides-dialog]');
  if (dialog && event.target === dialog) {
    dialog.close();
  }
});
